import axios from 'axios';
import Token from 'services/utils/token';

class Http {
    // eslint-disable-next-line class-methods-use-this
    async get(apiUrl, needToken = true, { cancelToken } = {}) {
        let config;
        if (needToken) {
            config = { headers: { Authorization: await Token.getToken() } };
        }

        if (cancelToken) {
            if (!config) {
                config = {};
            }

            config.cancelToken = cancelToken.token;
        }

        return axios.get(apiUrl, config);
    }

    // eslint-disable-next-line class-methods-use-this
    async post(apiUrl, data, needToken = true, { cancelToken } = {}) {
        let config;
        if (needToken) {
            config = { headers: { Authorization: await Token.getToken() } };
        }

        if (cancelToken) {
            if (!config) {
                config = {};
            }

            config.cancelToken = cancelToken.token;
        }

        return axios.post(apiUrl, data, config);
    }

    // eslint-disable-next-line class-methods-use-this
    async put(apiUrl, data, needToken = true) {
        let config;
        if (needToken) {
            config = { headers: { Authorization: await Token.getToken() } };
        }

        return axios.put(apiUrl, data, config);
    }

    // eslint-disable-next-line class-methods-use-this
    async delete(apiUrl) {
        return axios.delete(apiUrl, { headers: { Authorization: await Token.getToken() } });
    }

    createCancelToken() {
        return axios.CancelToken.source();
    }

    // eslint-disable-next-line class-methods-use-this
    isCancel(error) {
        return axios.isCancel(error);
    }
}

export default new Http();
